// src/slices/hrSettingsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchHrSettings } from "./hrSettingsThunks";

const initialState = {
    loading: false,
    data: {
        annual_leave_type: "",
        annual_leave_days: 0,
        sick_leave_days: 0,
        flexi_leave_days: 0,
        weekend_days: [],
        should_reset_accrued_leave: "no",
        leaves_carry_forward: "0",
        enable_late_deduction: "no",
        late_deduction_type: null,
        late_deduction_after_minutes: null,
        late_deduction_leave_type: "casual_leave",
        auto_checkout_duration_minutes: null,
        enable_unmarked_attendance_deduction: "no",
        unmarked_attendance_deduction_type: "casual_leave",
        unmarked_attendance_tolerance_days: 0,
        leave_backdate_days: 7,
        sick_leave_backdate_days: 7,
    },
    error: null,
    success: null, // ✅ to show success messages after update
};

const hrSettingsSlice = createSlice({
    name: "hrSettings",
    initialState,
    reducers: {
        resetHrSettingsState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            // 📌 Fetch
            .addCase(fetchHrSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHrSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.data = {
                    annual_leave_type: action.payload.annual_leave_type || "",
                    annual_leave_days: action.payload.annual_leave_days || 0,
                    sick_leave_days: action.payload.sick_leave_days || 0,
                    flexi_leave_days: action.payload.flexi_leave_days || 0,
                    weekend_days: action.payload.weekend_days || [],
                    should_reset_accrued_leave: action.payload.should_reset_accrued_leave || "no",
                    leaves_carry_forward: action.payload.leaves_carry_forward || "0",
                    enable_late_deduction: action.payload.enable_late_deduction || "no",
                    late_deduction_type: action.payload.late_deduction_type || null,
                    late_deduction_after_minutes: action.payload.late_deduction_after_minutes || null,
                    late_deduction_leave_type: action.payload.late_deduction_leave_type || "casual_leave",
                    auto_checkout_duration_minutes: action.payload.auto_checkout_duration_minutes || null,
                    enable_unmarked_attendance_deduction: action.payload.enable_unmarked_attendance_deduction || "no",
                    unmarked_attendance_deduction_type: action.payload.unmarked_attendance_deduction_type || "casual_leave",
                    unmarked_attendance_tolerance_days: action.payload.unmarked_attendance_tolerance_days ?? 0,
                    leave_backdate_days: action.payload.leave_backdate_days ?? 7,
                    sick_leave_backdate_days: action.payload.sick_leave_backdate_days ?? 7,
                };
            })
            .addCase(fetchHrSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load HR settings";
            })


    },
});

export const { resetHrSettingsState } = hrSettingsSlice.actions;
export default hrSettingsSlice.reducer;
